import React from "react";
import { IonHeader, IonContent, IonFooter, isPlatform } from "@ionic/react";
import Header from "./header.layout";
import Footer from "./footer.layout";

import "./layout.css";

const Layout = ({ children }: { children: any }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        height: "100%",
      }}
    >
      <IonHeader>
        <Header />
      </IonHeader>

      <div className="app-content">
        <IonContent>{children}</IonContent>
      </div>

      <IonFooter mode="ios">
        <Footer />
      </IonFooter>

      {(isPlatform("android") ||
        isPlatform("ios")) && <div style={{
          height: '50px'
        }}></div>}
    </div>
  );
};

export default Layout;
